var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMolecule(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:6px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M82.74,99.11l-13.92,6.44m46,32.77-5-22.16m44.26-5.11-25.56-10.24m24-43.76L124.32,77.32M101.62,69,98.57,51.75m72.84-.94A10.42,10.42,0,1,1,161,40.47,10.38,10.38,0,0,1,171.41,50.81Zm-64.93-9.08A10.42,10.42,0,1,1,96.06,31.38,10.38,10.38,0,0,1,106.48,41.73Zm81.59,76.56a17.72,17.72,0,1,1-17.72-17.61A17.66,17.66,0,0,1,188.07,118.29ZM130,92.68a24.06,24.06,0,1,1-24-23.89A24,24,0,0,1,130,92.68Zm14,68.75a24.06,24.06,0,1,1-24.06-23.89A24,24,0,0,1,144,161.43Zm-73.84-48.3a20,20,0,1,1-20-19.9A20,20,0,0,1,70.15,113.13Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMolecule);
export default __webpack_public_path__ + "static/media/MOLECULE.cfe6fd3c0da91527b27ffa3c0b6a9f27.svg";
export { ForwardRef as ReactComponent };